import React, {useState, useEffect, Fragment} from 'react';
import {Row, Form, Input, Select, Checkbox, message, Button, notification, Spin, Upload} from 'antd';
import {t} from 'utils/i18n';
import {WEATER_DATA_LABEL, PROVINCES_DISTRICTS, PROVINCE_PARAMS, DISTRIC_PARAMS, DETAIL_TABS} from 'consts'
import {useLocation} from 'react-router-dom';
import {merge, weather} from 'apis/datas';
import moment from 'moment';

const layout = {
	labelCol: {
		span: 4,
		align: "left"
	},
	wrapperCol: {
		span: 20
	},
	labelAlign: "left"
}

export default (props) => {
	const language = localStorage.getItem("lang")
	const {state: {data}} = useLocation()

	const [date_col, setDateCol] = useState("")
	const [save_as, setSaveAs] = useState(data.data_name + "_" + t(DETAIL_TABS.MERGE) + "_" + moment().format("YYYY-MM-DD_HH:mm"))
	const [messageDateCol, setMessageDateCol] = useState("")
	const [messageSaveAs, setMessageSaveAs] = useState("")
	const [fileData, setFileData] = useState("")
	const [fileList, setFileList] = useState([])
	const [loading, setLoading] = useState(false)
	const [saveAsLoading, setLoadingSaveAs] = useState(false)

	useEffect(() => {
		return () => {
			setMessageDateCol("")
			setDateCol("")
			setSaveAs(data.data_name + "_" + t(DETAIL_TABS.WEATHER) + "_" + moment().format("YYYY-MM-DD_HH:mm"))
		}
	}, [props.activeKey])


	const _onChangeTimeData = (value) => {
		setDateCol(value)
		setMessageDateCol("")
	}

	const _onChangeSaveAs = ({target: {value}}) => {
		setSaveAs(value || "")
		setMessageSaveAs("")
	}

	const _validate = (body) => {
		let flag = false
		if (!body.col) {
			setMessageDateCol(t("Please input %1", t("column")))
			flag = true
		}
		// if (body.save_as !== null && body.save_as !== undefined && body.save_as.trim() === "") {
		// 	setMessageSaveAs(t("Please input %1", t("Data Name")))
		// 	flag = true
		// } else {
		// 	setMessageSaveAs("")
		// }
		if (flag) {
			return false
		}
		return true
	}

	const _onSubmit = (body, _setLoading) => async () => {
		if (!_validate(body)) {
			return
		}
		_setLoading(true)
		let formData = new FormData()
		formData.append('data_id', body.data_id)
		formData.append('col', body.col)
		formData.append('save_as', body.save_as)
		formData.append('project_id', body.project_id)
		formData.append('file', body.file.originFileObj)
		const response = await merge(formData);
		if (response.status === 200) {
			notification.success({
				message: t("Success")
			})
		} else {
			notification.error({
				message: t("Error"),
				description: t(response.data.message)
			})
		}
		_setLoading(false)
	}
	let customRequest = () => {

	}
	let onChangeFileUpload = (info) => {
		info.file.status = 'done'
		setFileData(info.file)
		setFileList([info.file])
	}

	const clearFileField = () => {
		setFileList([])
		return false;
	}

	return (
		<Row>
			<Spin spinning={loading || saveAsLoading}>
				<Form {...layout} className="merge-data-tab">
					<Form.Item label={<strong>{t("Merge column")}</strong>} help={messageDateCol}>
						<div style={{width: 300}}>
							<Select
								showSearch
								onChange={_onChangeTimeData}
								value={date_col}
							>
								{
									props.dataTabView.columns instanceof Array && props.dataTabView.columns.map((data, index) => (
										<Select.Option value={data}>{data}</Select.Option>
									))
								}
							</Select>
						</div>
					</Form.Item>
					<Form.Item label={<strong>{t("Upload Data")}</strong>} help={messageDateCol}>
						<div style={{width: 300}}>
							<Upload fileList={fileList}
											customRequest={customRequest}
											onChange={onChangeFileUpload}
											onRemove={clearFileField}
											type="file"
											showUploadList={{ showDownloadIcon: false }}
							        className='input-upload-file'>
								<Button>{t('Upload Data')}</Button>
							</Upload>
						</div>
					</Form.Item>
					<Row style={{textAlign: 'right', marginTop: '10px'}} type="flex" justify="end">
						<Row type='flex' justify='space-between' style={{width: "35%"}} align="center">
							<span style={{lineHeight: '31px', width: '27%', marginRight: 5}}>{t('Data name')}:</span>
							<Input style={{width: "70%"}} value={save_as} onChange={_onChangeSaveAs}/>
						</Row>
						<Button style={{marginLeft: 5}} type="primary" loading={saveAsLoading} onClick={_onSubmit({
							data_id: data.data_id,
							col: date_col,
							save_as: save_as,
							project_id: data.project_id,
							file: fileData
						}, setLoadingSaveAs)}>
							{t('Save As')}
						</Button>

						<Button style={{marginLeft: 30}} type="primary" loading={loading} onClick={_onSubmit({
							col: date_col,
							save_as: '',
							data_id: data.data_id,
							project_id: data.project_id,
							team_id: '',
							file: fileData
						}, setLoading)}>
							{t('Save')}
						</Button>

					</Row>
				</Form>
			</Spin>
		</Row>
	)
}
